export const update = payload => {
  return {
    type: 'settings/update',
    payload,
  }
}
